var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrushRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6601 5.33997C18.3098 5.00638 17.8447 4.82031 17.3611 4.82031C16.8774 4.82031 16.4123 5.00638 16.0621 5.33997L9.33785 12.06C9.12866 12.0197 8.91609 11.9996 8.70305 12C8.26997 11.9987 7.84095 12.0834 7.44083 12.2491C7.04071 12.4148 6.67744 12.6583 6.37205 12.9654C5.22005 14.1198 4.91165 17.7768 4.86005 18.498L4.81445 19.1856L5.50145 19.1376C6.22145 19.0884 9.88145 18.7818 11.0347 17.628C11.4161 17.2454 11.6977 16.7749 11.8546 16.258C12.0116 15.741 12.0391 15.1934 11.9347 14.6634L18.6601 7.93797C19.0037 7.59297 19.1966 7.12589 19.1966 6.63897C19.1966 6.15205 19.0037 5.68497 18.6601 5.33997ZM10.1863 16.7796C9.62825 17.337 7.62605 17.7156 6.12185 17.8776C6.29165 16.3176 6.68765 14.3472 7.22045 13.8138C7.6202 13.4537 8.14287 13.2608 8.68067 13.2749C9.21846 13.2889 9.73036 13.5088 10.1108 13.8893C10.4912 14.2697 10.7111 14.7816 10.7251 15.3194C10.7392 15.8571 10.5463 16.3798 10.1863 16.7796ZM17.8129 7.08957L11.4403 13.4628C11.2035 13.1043 10.8975 12.7966 10.5403 12.558L16.9105 6.18717C17.0317 6.07142 17.1928 6.00683 17.3605 6.00683C17.5281 6.00683 17.6892 6.07142 17.8105 6.18717C17.87 6.2462 17.9173 6.3164 17.9496 6.39374C17.9819 6.47108 17.9987 6.55404 17.9989 6.63787C17.9991 6.7217 17.9828 6.80475 17.9509 6.88226C17.919 6.95977 17.8721 7.03022 17.8129 7.08957Z",
    fill: "#EA429D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushRainbow);
export default __webpack_public_path__ + "static/media/brushRainbow.84e157f85c86fb56ec8aea75cc457dcd.svg";
export { ForwardRef as ReactComponent };